@if (localConfig) {
  <mwe-basic-card
    [cardTitle]="localConfig.titleKey"
    [hasBackground]="true"
    [headingNodeType]="headingNodeType"
    iconClass="fas fa-gift-card"
  >
    <div class="row">
      <div class="col-12">
        <div class="has-text-button">
          <div class="pb-2 pt-2">
            <mwe-form
              #codeForm
              (formIsInvalid)="onFormChange($event)"
              (formIsValid)="onFormChange($event)"
              [formModel]="voucherFormModel"
              [suppressValidityCheckOnSubmit]="true"
            />
            @if (showWLFields) {
              <mwe-wl-voucher-form
                (checkPressed)="wlFormCheckPressed($event)"
                (formValid)="wlFormValidityChanged($event)"
                [aktionsArt]="aktionsArt"
                [config]="localConfig"
                [loading]="loading"
                [prozesstyp]="prozesstyp"
              />
            }
          </div>
        </div>
      </div>
    </div>
    @if (localConfig.infoText) {
      <div class="row pb-2">
        <mwe-infobox [messageKey]="localConfig.infoText" />
      </div>
    }
  </mwe-basic-card>
}

@if (!!codeCheck) {
  <div class="mt-5">
    @if (codeCheck === 'invalid') {
      <mwe-inline-notification
        [messageKey]="showWLFields ? localConfig.invalidCodeWLMsgKey : localConfig.invalidCodeMsgKey"
        titleKey="voucher.invalidTitle"
        type="danger"
      />
    }
    @if (codeCheck === 'error') {
      <mwe-inline-notification
        [messageKey]="errorMessageKey"
        [titleKey]="errorTitleKey || 'voucher.invalidTitle'"
        [type]="errorAlertStyle"
      />
    }
    @if (codeCheck === 'warning') {
      <mwe-infobox
        (onCTAClick)="handleWarningLinkClicked()"
        [infoText]="isTariffNotValidError ? tariffNotValidInfoText : null"
        [ctaLabelKey]="isTariffNotValidError ? 'voucher.validity.tariffNotValid.link' : ''"
        [messageKey]="errorMessageKey"
        type="warning"
      />
    }
    @if (codeCheck === 'valid') {
      <mwe-basic-card cardTitle="voucher.validity.success.title" headingNodeType="p" iconClass="fas fa-gift-card">
        <mwe-green-check-list [labels]="uiSuccessInfos" />
      </mwe-basic-card>
    }
  </div>
}
